// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.

import fn from '../../endOfWeek/index.js'
import convertToFP from '../_lib/convertToFP/index.js'

var endOfWeekWithOptions = convertToFP(fn, 2)

export default endOfWeekWithOptions



//////////////////
// WEBPACK FOOTER
// ./node_modules/date-fns/esm/fp/endOfWeekWithOptions/index.js
// module id = 1415
// module chunks = 18